<template>
  <div class="profile">
    <div class="profile-box">
      <div class="title">福建光线科技</div>
      <div class="profile-text"><span style="opacity: 0">空空</span>福建光线科技有限公司，成立于2016年，注册资金5000万元，公司位于福建省最大的软件产业园（福州软件园），是该园区标杆企业之一。
      </div>
      <div class="profile-text"><span style="opacity: 0">空空</span>公司是一家基于互联网门店新零售的服务商，凭借丰富的互联网渠道建设及运营经验，致力于帮助商家实现在线化和数字化商业模式，通过专业化的建设并运营互联网新零售门店，建设数字化商品线上全渠道销售运营模式，构建立体化流量入口生态，完善品牌矩阵建设，实现线上线下商业闭环，并助力企业实现数字化转型升级。自主研发的互联网新零售门店管理平台，通过整合数字产品及服务提供商，采用自营或代运营模式，在微信、天猫、淘宝、支付宝、QQ、快应用、百度、头条、抖音等不同生态平台提供数字商品销售运营服务，目前已经开设数百家新零售门店，服务粉丝3000千万，规模超过10亿。互联网新零售门店管理平台提供数字商品销售、一站式支付、营销工具、代理商管理、专题活动、积分商域、个人中心等功能模块。
      </div>
      <div class="profile-text"><span style="opacity: 0">空空</span>公司特别重视研发能力培养，通过校企合作、内外部联盟等资源整合，形成较为强大的开发水准，拥有21件软著、并且获得省通信管理局颁发的ICP证书、中国诚信供应商企业、文化网络经营许可证、2019年福州市“双百双千”增产增效企业之一等称号、省级瞪羚企业。
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      IMG: this.img_host,
    }
  },
  // 页面创建前
  beforeCreate() {
    // document.querySelector('body').setAttribute('style', 'background:#f7f7f7');
  },
  methods: {}
}

</script>
<style scoped>
.profile {
  display: flex;
  justify-content: center;
}
.profile .profile-box {
  width: 1200px;
  background: #fff;
  min-height: 80vh;
  padding: 30px 100px;
  box-sizing: border-box;
  margin-top: 10px;
}

.profile .title {
  font-size: 18px;
  color: #111;
  font-weight: 600;
  text-align: center;
}
.profile .profile-text {
  font-size: 16px;
  color: #666;
  margin-top: 20px;
  line-height: 1.8;
}

</style>



// WEBPACK FOOTER //
// src/components/profile.vue